import React from 'react';
import { Supplier_supplier } from '../../../__generated__/Supplier';
import { SupplierAvailableDocumentTypes } from '../__generated__/SupplierAvailableDocumentTypes';
import { AttachFormModal } from './AttachFormModal';
import { useFormContext } from 'react-hook-form';
interface AttachFormProps {
  availableDocumentTypes: SupplierAvailableDocumentTypes | undefined;
  supplier: Supplier_supplier;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  supplier,
  availableDocumentTypes,
}) => {
  const { formState: { isDirty } } = useFormContext<any>();
  return (
    <AttachFormModal
      supplier={supplier}
      availableDocumentTypes={availableDocumentTypes}
      isDirty={isDirty}
    />
  );
};
